import { createAction } from 'redux-actions';
import { GroupFolderId } from './types';
import { PapiDeviation, PapiUser } from '@wix/da-papi-types';
import { actionKey } from './constants';

export const initGroupsPanel = createAction(`${actionKey}.INIT_GROUPS`, () => ({}));

export const initRecommendedGroups = createAction(
  `${actionKey}.INIT_RECOMMENDED_GROUPS`,
  () => ({})
);

export const addToGroupFolder = createAction(
  `${actionKey}.ADD_TO_FOLDER`,
  (
    deviation: PapiDeviation,
    group: PapiUser,
    groupFolderId: GroupFolderId,
    actionbarType?: string,
    biData?: any
  ) => ({
    deviation,
    group,
    groupFolderId,
    actionbarType,
    biData,
  })
);
export const addToGroupFolderSuccess = createAction(
  `${actionKey}.ADD_TO_FOLDER_SUCCESS`,
  (deviationId: number, groupFolderId: GroupFolderId, suggested: boolean) => ({
    deviationId,
    groupFolderId,
    suggested,
  })
);
export const addToGroupFolderFail = createAction(
  `${actionKey}.ADD_TO_FOLDER_FAIL`,
  (deviationId: number, groupFolderId: GroupFolderId) => ({
    deviationId,
    groupFolderId,
  })
);
